import { DocumentNode } from 'graphql';

import { getFragmentDefinitionNode } from './getFragmentDefinitionNode';

/**
 * Retourne le __typename d'un documentNode de fragment généré par codegen.
 */
export const getFragmentTypename = (documentNode: DocumentNode) => {
  return getFragmentDefinitionNode(documentNode).typeCondition.name.value;
};
